import React from "react";
import { logMetric } from "@/perf/collector";

interface Props {
  children: React.ReactNode;
}
interface State {
  hasError: boolean;
  error?: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    try {
      logMetric({
        type: "error",
        name: error.name,
        timestamp: Date.now(),
        extra: { message: error.message, stack: error.stack, info },
      });
    } catch {
      // ignore logging failures
    }

    // Forward to global error tracking if configured (Sentry/LogRocket)
    // @ts-ignore
    if ((window as any).Sentry?.captureException) {
      // @ts-ignore
      (window as any).Sentry.captureException(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="p-4 text-center">
          Something went wrong.
        </div>
      );
    }
    return this.props.children;
  }
}
